import { render, staticRenderFns } from "./chating.vue?vue&type=template&id=563b46d8&scoped=true&"
import script from "./chating.vue?vue&type=script&lang=js&"
export * from "./chating.vue?vue&type=script&lang=js&"
import style0 from "./chating.vue?vue&type=style&index=0&id=563b46d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b46d8",
  null
  
)

export default component.exports